/**
 * CR228: Deal Type Filter Block
 * 
 * Renders deal type filter pills as a Layout Studio block.
 * This replaces the hardcoded DealTypeFilter in ResultsBlock.
 * 
 * Layout Studio controls:
 * - Whether this block appears at all (enabled/disabled)
 * - Block order relative to other blocks
 * - Future: styling variants, compact mode, etc.
 */

import type { BlockProps } from "./types";
import { DealTypeFilter } from "@/components/deals/DealTypeFilter";

export interface DealTypeFilterBlockConfig {
  /** Whether to show the "Unclassified" category (admin only by default) */
  showUnclassified?: boolean;
  /** Future: styling variant */
  variant?: "pills" | "dropdown" | "compact";
}

export function DealTypeFilterBlock({ config, context }: BlockProps<DealTypeFilterBlockConfig>) {
  const showUnclassified = config?.showUnclassified ?? context.isAdmin;
  
  return (
    <div className="py-2">
      <DealTypeFilter
        selectedTypes={context.selectedDealTypes}
        onSelectionChange={context.onDealTypesChange}
        disableUnclassified={!showUnclassified}
      />
    </div>
  );
}
